export default __webpack_public_path__ + "static/media/steve.b880e25a.jpeg";